import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { first } from 'rxjs';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
import { DepartmentDashboardService } from 'src/app/services/department-dashboard.service';
import { FarmersApplicationService } from 'src/app/services/farmers-application.service';
import { FarmersDetailsService } from 'src/app/services/farmers-details.service';
import { IpAddressService } from 'src/app/services/ip-address.service';
import { ReportsService } from 'src/app/services/reports.service';

@Component({
  selector: 'app-new-registration',
  templateUrl: './new-registration.component.html',
  styleUrls: ['./new-registration.component.scss']
})
export class NewRegistrationComponent implements OnInit {

  public newRegForm: FormGroup;
  public userId: any;
  public farmerData: any;

  public ipAddress: any = '000.000.000';
  public showKYCPopUpDialog: boolean = false;
  
  constructor(
    public router: Router,
    private fb: FormBuilder,
    private loader: AppLoaderService,
    private fApplicationService: FarmersApplicationService,
    private messageService: MessageService,
    private _personalDetalSer: FarmersDetailsService,
    private ipService: IpAddressService,
    private reportService: ReportsService,
    private deptDashBoardService: DepartmentDashboardService,
    private cryptoJsService: CryptoJsService,
  ) { }

  ngOnInit(): void {
    let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    this.userId = JSON.parse(payload)?.sub;

    this.getIP();

    this.newRegForm = this.fb.group({
      aadharNo: [
        '',
        [
          Validators.required,
          Validators.minLength(12),
          Validators.maxLength(12),
        ],
      ],
    });
  }

  onSubmitfarmerOwnMIDetails() {
    if (!this.newRegForm.invalid) {
      let val = this.newRegForm.value;
      // let reqBody = {
      //   aadharNo: val?.aadharNo,
      //   userId: this.userId,
      //   networkId: this.ipAddress,
      //   terminalId: this.ipAddress
      // }

      this.showKYCPopUpDialog = true;

      this.farmerData = {
        Aadhar_No: val?.aadharNo,
        AadharStatus: false
      }
      // this.submitDetails(reqBody);
      // this.checkAppVal(reqBody);
    } else {
      this.newRegForm.markAllAsTouched();
      // this.messageService.add({
      //   severity: 'info',
      //   summary: 'Info Message',
      //   detail: 'Fill all madatory details.',
      // });
    }
  }

  // submitDetails(reqBody) {
  //   this.loader.start();
  //   this.fApplicationService
  //     .uploadUHBVNFieldXENNoc(reqBody)
  //     .pipe(first())
  //     .subscribe({
  //       next: (res) => {
  //         this.loader.close();
  //         if (res == 'Success') {
  //           this.messageService.add({
  //             severity: 'success',
  //             summary: 'Success Message',
  //             detail: res,
  //           });
  //           this.newRegForm.reset();
  //         } else {
  //           this.messageService.add({
  //             severity: 'info',
  //             summary: 'Info Message',
  //             detail: res,
  //           });
  //         }
  //       },
  //       error: (err) => {
  //         this.loader.close();

  //         this.messageService.add({
  //           severity: 'error',
  //           summary: 'Error Message',
  //           detail: err,
  //         });
  //       },
  //     });
  // }

  getIP() {
    if (sessionStorage.getItem('ipAddress')) {
      this.ipAddress = JSON.parse(window.sessionStorage.getItem('ipAddress'));
    } else {
      this.ipService.getIPAddress().subscribe((res: any) => {
        this.ipAddress = res.ip;
        sessionStorage.setItem('ipAddress', JSON.stringify(this.ipAddress));
      });
    }
  }

  hideKYCDialog(){
    this.showKYCPopUpDialog = false;
  }

  addItem(val){
    this.showKYCPopUpDialog = false;
  }

}
